import { render, staticRenderFns } from "./BindPhoneAccount.vue?vue&type=template&id=2391893a&scoped=true"
import script from "./BindPhoneAccount.vue?vue&type=script&lang=js"
export * from "./BindPhoneAccount.vue?vue&type=script&lang=js"
import style0 from "./BindPhoneAccount.vue?vue&type=style&index=0&id=2391893a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2391893a",
  null
  
)

export default component.exports